import { ComparerContext } from '@/context/ComparerContext';
import { useState } from 'react';

export const ComparerContextProvider = ({ children }: { children: React.ReactNode }) => {
  const [showUnchanged, setShowUnchanged] = useState<boolean>(false);
  const [expandAll, setExpandAll] = useState<boolean>();

  return (
    <ComparerContext.Provider
      value={{
        showUnchanged: showUnchanged,
        setShowUnchanged: setShowUnchanged,
        expandAll: expandAll,
        setExpandAll: setExpandAll
      }}
    >
      {children}
    </ComparerContext.Provider>
  );
};
